export const elRed = '#EB1C22';
export const elGreen = '#006B00';
export const elGray = '#D9D9D9';
export const iconGray = '#828282';
export const elLightGray = '#F0F0F0';
export const elLightLightGray = '#F9F9F9';
export const mentionHighlight = '#d5eff7';
export const mediumText = '#818181'; // gray
export const menuBackground = '#454545'; // dark gray
export const highlight = '#3b9bd7'; // light blue
export const mediumHighlight = '#3379a5'; // medium blue
export const darkHighlight = '#054974'; // dark blue
export const pageBackground = '#f5f5f5'; // light gray
export const receivedBackground = '#fafafa'; // light gray
export const darkText = '#3b3b3b'; // dark gray
export const lightText = '#b9b9b9'; // light gray

export const buttonBackground = elRed;
export const titleColor = elRed;
export const titleBackground = elGreen;
export const informationText = elRed;
export const textGray = elGray;
export const disabled = iconGray;

const colors = {
  elRed,
  elGreen,
  elGray,
  iconGray,
  elLightGray,
  elLightLightGray,
  mentionHighlight,
  buttonBackground,
  titleColor,
  titleBackground,
  informationText,
  textGray,
  disabled,
  mediumText: '#818181', // gray
  menuBackground: '#454545', // dark gray
  highlight: '#3b9bd7', // light blue
  mediumHighlight: '#3379a5', // medium blue
  darkHighlight: '#054974', // dark blue
  pageBackground: '#f5f5f5', // light gray
  receivedBackground: '#fafafa', // light gray
  darkText: '#3b3b3b', // dark gray
  lightText: '#b9b9b9', // light gray
  biddingOrange: '#ff8c00',
  biddingPurple: '#800080',
  biddingPink: '#ee82ee',
  biddingGreen: '#006400',
  biddingRed: '#eb1b22',
  biddingBrightRed: '#ff0000',
  biddingELGreen: '#7cfc01',
  biddingEFTurquoise: '#01fccf',
  biddingPBCyan: '#01edfc',
  biddingFLBlue: '#01c0fc',
  biddingSkyBlue: '#0091cf',
  biddingMagenta: '#cf00ba',
  biddingStepGreen: '#0b8600',
  biddingAcceptGreen: '#00c242',
  biddingGrayButton: '#848282',
  biddingDarkGrayButton: '#5b5959',
  biddingTableRow: '#e6e6e6'
};

colors.track = {
  false: colors.lightText, true: colors.lightText
};

export default colors;